<template>
  <div>
    <List v-for="list in lists" :key="list.title" class="mb-3 mb-md-4" :list="list" />
  </div>
</template>

<script>
import List from "./List";

export default {
  components: {
    List,
  },
  props: {
    lists: {
      type: Array,
      required: true,
    },
  },
};
</script>
